import { skipToken, useQuery } from '@tanstack/react-query';

import { Automations } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_AUTOMATION_KEY = 'PRIVATE_AUTOMATION';

export type PrivateAutomationKey = [typeof PRIVATE_AUTOMATION_KEY, UsePrivateAutomationParams];

export const getPrivateAutomationKey = (params: UsePrivateAutomationParams): PrivateAutomationKey => [
  PRIVATE_AUTOMATION_KEY,
  params,
];

export type UsePrivateAutomationParams = Omit<
  NonNullable<Parameters<typeof Automations.get>[0]>,
  'workspaceId' | 'automationId'
> & {
  workspaceId: string | undefined;
  automationId: string | undefined;
};

export type UsePrivateAutomationOptions = {
  enabled?: boolean;
};

export const usePrivateAutomation = (params: UsePrivateAutomationParams, options?: UsePrivateAutomationOptions) => {
  const { workspaceId, automationId } = params;

  return useQuery({
    queryKey: getPrivateAutomationKey(params),
    queryFn:
      workspaceId && automationId ? () => callAirApi(() => Automations.get({ workspaceId, automationId })) : skipToken,
    enabled: !!workspaceId && !!automationId && options?.enabled !== false,
  });
};
